import { Outlet } from 'react-router'
import ForbiddenPage from '@/pages/forbidden/ForbiddenPage.tsx'
import useGetCurrentModuleInfo from '@/core/hooks/useGetCurrentModuleInfo.ts'
import NotFoundPage from '@/pages/notFound/NotFoundPage.tsx'
import useHasPermissions from '@/core/hooks/useHasPermissions.ts'
import { appConfig } from '@/config/app.ts'
import { useAppSelector } from '@/globalStore/hooks.ts'

const ModuleGuard = () => {
  const { currentModuleName, currentViewName } = useGetCurrentModuleInfo()
  const { hasPermissions } = useHasPermissions()
  const { loggedUser } = useAppSelector((state) => state.global)

  if (currentModuleName === 'marketplace' && loggedUser) {
    if (!loggedUser.isWeppa && !loggedUser.hasMarketplace)
      return <ForbiddenPage />
  }

  const currentModule = appConfig.systemModules.find(
    (module) => module.systemName === currentModuleName
  )

  if (!currentModule) {
    return <NotFoundPage />
  }

  const currentView = currentModule.views.find(
    (view) => view.systemName === currentViewName
  )

  if (currentView && hasPermissions([currentView.permission])) {
    return <Outlet />
  } else return <ForbiddenPage />
}

export default ModuleGuard
